var map = {
	"./excel.png": "3087",
	"./image.png": "eefb",
	"./none.png": "649d",
	"./pdf.png": "cdb5",
	"./ppt.png": "f217",
	"./txt.png": "997e",
	"./word.png": "cd32",
	"./zip.png": "99e0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cb2d";